import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { Button } from "@/DesignSystem";

import styles from "./LoginMultifactorAuthenticationPopup.module.scss";

interface ILoginMultifactorAuthenticatorPopupProps {
    stringProvider?: ResourceProvider;
    onSkipMultifactorAuthenticationSetup: () => void;
    onClickMultifactorAuthenticationSetup: () => void;
}

function LoginMultifactorAuthenticationPopup(props: Readonly<ILoginMultifactorAuthenticatorPopupProps>): JSX.Element {
    const { getText } = useTranslation(props.stringProvider);
    const rehypeRawPlugin: any = rehypeRaw;
    function renderFooter(): JSX.Element {
        return (
            <div className={styles.footerContainer}>
                <Button
                    variant="neutral"
                    category="secondary"
                    label={getText("LoginMultifactorAuthenticationSetUp_SkipButton")}
                    onClick={props.onSkipMultifactorAuthenticationSetup}
                    dataCy="login-MultifactorAuthenticationSkipButton"
                />
                <Button
                    variant="brand"
                    category="primary"
                    label={getText("LoginMultifactorAuthenticationSetUp_SetUpButton")}
                    onClick={props.onClickMultifactorAuthenticationSetup}
                    dataCy="login-MultifactorAuthenticationSetUpButton"
                />
            </div>
        );
    }
    function renderHeader(): JSX.Element {
        return (
            <div className={styles.popupTitle}>
                {getText("LoginMultifactorAuthenticationSetUp_Title")}
            </div>
        );
    }

    return (
        <Modal
            header={renderHeader()}
            centerContent
            fixedOverlayPosition
            showOverlay
            disableOverlayClose
            footer={renderFooter()}
            dataCy="login-MultifactorAuthenticationSetUpPopup"
        >
            <div>
                <ReactMarkdown rehypePlugins={[rehypeRawPlugin]}>
                    {getText("LoginMultifactorAuthenticationSetUp_Explanation")}
                </ReactMarkdown>
                <br />
                <ReactMarkdown rehypePlugins={[rehypeRawPlugin]}>
                    {getText("LoginMultifactorAuthenticationSetUp_SkipPopupMessage")}
                </ReactMarkdown>
            </div>
        </Modal>
    );
}

export { LoginMultifactorAuthenticationPopup };
